export const formatDisplayName = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/-/g, " ")
    .replace(/_/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getProviderWelcomePageUrl = (firstName: string, lastName: string): string => {
  return (
    `https://www.getmanatee.com/therapist/` +
    [firstName, lastName].map(name => name.replace(/\s+/g, "").replace(/[''"]/g, "").toLowerCase()).join("-")
  );
};
